import { render, staticRenderFns } from "./ProductOther.vue?vue&type=template&id=8ae3285a&scoped=true"
import script from "./ProductOther.vue?vue&type=script&lang=js"
export * from "./ProductOther.vue?vue&type=script&lang=js"
import style0 from "./ProductOther.vue?vue&type=style&index=0&id=8ae3285a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae3285a",
  null
  
)

export default component.exports
import {QCarousel,QCarouselSlide,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCarousel,QCarouselSlide,QImg})
